import type { PostAuthenticationSessionParsedResponse } from "webApp";
import type { PostAuthenticationSessionRequestResponse } from "wagAPI";
export const postAuthenticationSessionResponseParser = (response: PostAuthenticationSessionRequestResponse): PostAuthenticationSessionParsedResponse => response;